import React from 'react';
import Grid from '@material-ui/core/Grid';
import terra1 from "../images/terra1.jpg"
import pascolo from "../images/pascolo.jpg"
import bergamotto1 from "../images/bergamotto1.jpg"
import bergamotto2 from "../images/bergamotto2.jpg"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        overflowX: "hidden",
    },
    container1: {
        margin: "50px",
        padding: "4%",
        fontSize: "20px"
    },
    container2: {
        margin: "50px",
        padding: "4%",
        border: "5px solid #707070",
        borderRadius: "20px",
    },
    terra: {
        width: "100%",
        minHeight: "300px",
        backgroundImage: `url(${terra1})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 600px",
        display: "flex",
        position: "relative",
        margin: "50px",
        padding: "4%",
        border: "5px solid #707070",
        borderRadius: "20px",
    },
    pascolo: {
        width: "100%",
        minHeight: "300px",
        backgroundImage: `url(${pascolo})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 600px",
        display: "flex",
        position: "relative",
        margin: "50px",
        padding: "4%",
        border: "5px solid #707070",
        borderRadius: "20px",
    },
    bergamotto1: {
        width: "100%",
        backgroundImage: `url(${bergamotto1})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        display: "flex",
        position: "relative",
        margin: "50px",
        padding: "4%",
        border: "5px solid #707070",
        borderRadius: "20px",
    },
    bergamotto2: {
        width: "100%",
        backgroundImage: `url(${bergamotto2})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        display: "flex",
        position: "relative",
        margin: "50px",
        padding: "4%",
        border: "5px solid #707070",
        borderRadius: "20px",
    },
}));

function Contacts() {
    const classes = useStyles();

    return (
        <Grid container spacing={2} className={classes.root} flexDirection="column">
            <Grid item xs={5} className={classes.terra} > </Grid>
            <Grid item xs={5} className={classes.container1}>
                <h1>La nostra azienda</h1>
                <p>Piccola azienda familiare, l' <b>Azienda agricola Morabito</b> nasce con l'obbiettivo
                di produrre prodotti di qualità seguenda la tradizione di un'agricoltura sostenibile.</p>
                <p>Nata nel 2000 grazie a Paolo Morabito a Bova Marina, in provincia di Reggio Calabria, l'azienda si estende per 6 ettari quadrati in cui vengono coltivati
                    ulivi, bergamotti e una grande varietà di ortaggi tra cui pomodori, melanzane, zucche, cipolle e molto altro.</p>
                <p> Guidata dal 2020 dal figlio, Rocco Morabito, l'azienda risulta essere più giovane e dinamica pur seguendo le tradizioni e i valori trasmessi dal padre</p>
            </Grid>

            <Grid item xs={3} className={classes.bergamotto1} > </Grid>
            <Grid item xs={3} className={classes.container1}>
                <h1>Di spicco</h1>
                <p>Il <b>Bergamotto</b> è la componente di spicco della nostra azienda</p>
                <p>Il clima e la terra, splendida e rigogliosa, presente in questa zona rendono la coltivazione
                    del bergamotto unica nel suo genere. Infatti risulta essere un frutto prolifero unicamente in questa particolare zona,                </p>
            </Grid>
            <Grid item xs={3} className={classes.bergamotto2} > </Grid>


            <Grid item xs={5} className={classes.pascolo}  > </Grid>
            <Grid item xs={5} className={classes.container1}>
                <h1>Non solo terra</h1>
                <p>Oltre alla passione per la terra ci occupiamo anche di allevanto.</p>
                <p>Alla interno della nostra azienda sono presenti anche animali da allevamento quali: maiali, mucche, galline e pecore</p>
            </Grid>
        </Grid>
    );
}

export default Contacts;
